export function parseISOString(textDate: string, withHours: boolean = false): Date {
  // Ignora hora minuto y segundo
  const splited = textDate.trim().split(/\D+/);
  const numberArray = splited.filter((a) => !!a).map((a) => +a);
  // eslint-disable-next-line prefer-const
  let [year, month, day, hour, ...others] = numberArray;
  if (withHours) {
    return new Date(Date.UTC(year, --month, day, hour, ...others));
  }
  return new Date(Date.UTC(year, --month, day, 12, ...others));
}
